/**
 * Dominion collection filter & sort drawer.
 * The drawer contains a plain GET form, so filtering works through Shopify's storefront filtering URLs.
 */
if (!customElements.get('dg-filter-drawer')) {
  class DgFilterDrawer extends HTMLElement {
    /** @type {HTMLElement | null} */
    panel = null;
    /** @type {HTMLElement | null} */
    overlay = null;
    /** @type {HTMLElement | null} */
    opener = null;

    connectedCallback() {
      this.panel = this.querySelector('.dg-fdrawer');
      this.overlay = this.querySelector('.dg-fdrawer__overlay');

      const section = this.closest('.shopify-section') ?? document;
      this.opener = section.querySelector('[data-dg-filter-open]');
      this.opener?.addEventListener('click', this.open);
      this.querySelectorAll('[data-dg-filter-close]').forEach((el) => el.addEventListener('click', this.close));
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.opener?.removeEventListener('click', this.open);
      document.documentElement.style.overflow = '';
    }

    open = () => {
      const { panel, overlay } = this;
      if (!panel) return;

      panel.hidden = false;
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(() => panel.classList.add('is-open'));
      this.opener?.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      /** @type {HTMLElement | null} */ (panel.querySelector('button, select, input'))?.focus();
    };

    close = () => {
      const { panel, overlay } = this;
      if (!panel || panel.hidden) return;

      panel.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      this.opener?.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';

      const hide = () => {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      };
      panel.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 400);
      this.opener?.focus();
    };

    /** @param {KeyboardEvent} event */
    onKeydown = (event) => {
      const { panel } = this;
      if (!panel || panel.hidden) return;

      if (event.key === 'Escape') {
        this.close();
        return;
      }

      if (event.key === 'Tab') {
        const focusables = [
          .../** @type {NodeListOf<HTMLElement>} */ (
            panel.querySelectorAll('a[href], button, input:not([disabled]), select')
          ),
        ].filter((el) => el.offsetParent !== null);
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (!first || !last) return;

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };
  }

  customElements.define('dg-filter-drawer', DgFilterDrawer);
}
